import { useEffect, useState } from 'react';

import { omitGraphErrorValues } from '../Utils/chart_utils';
import {
  climateInfoGraphKeys,
  subscribeToInfoGraphChanges
} from '../Utils/info_graph_subscription';
import { graphPoints } from '../Utils/info_graph_utils';

function readClimateGraph(infos, key) {
  const values = omitGraphErrorValues(infos[key] ?? []);
  const indices = infos.climate_sample_indices ?? [];

  return indices.length === values.length && indices.length > 0
    ? graphPoints(Array.from(indices), values)
    : values;
}

function readClimateGraphs(infos) {
  return {
    humidity: readClimateGraph(infos, 'humidity_graph'),
    temperature: readClimateGraph(infos, 'temp_graph')
  };
}

export default function useInfoClimateGraphs(infos) {
  const [graphs, setGraphs] = useState(() => readClimateGraphs(infos));

  useEffect(() => {
    const updateGraphs = () => setGraphs(readClimateGraphs(infos));
    updateGraphs();
    return subscribeToInfoGraphChanges(infos, climateInfoGraphKeys, updateGraphs);
  }, [infos]);

  return graphs;
}
